import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
declare var app;
@Component({
  selector: 'app-a2-activity-center',
  templateUrl: './a2-activity-center.component.html',
  styleUrls: ['./a2-activity-center.component.scss']
})
export class A2ActivityCenterComponent extends GridBaseCase implements AfterViewInit{

  month: any = new Date();
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate=null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  pageName:string = null;
  tabsIndex = 1;// 今日活动1 活动预告2 历史活动0
  initLoadData:boolean = true;//第一次加载数据
  searchPlaceholder:string = null;//搜索框占位符
  searchValue:string = null;//查询内容
  isShowSearchInput:boolean = false;//是否显示搜索框
  activaType:any = 0;//活动类型
  activaArrayList:any = [];//活动类型数组
  selectText:string = null;//选中的门店名字
  isLeading:Boolean = false;//大区、省区、管理层
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    let that = this;
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    if(that.com.GetAccount.Roles){
      that.com.GetAccount.Roles.forEach(item=>{
        if(item.Code == "1007" || item.Code == "1008" || item.Code == "1009"){
          that.isLeading = true;
        }
      })
    }
  }

     /**
   * 搜索事件
   * @param e 
   */
  serarEvent(e,type:string = 'type'){ 
    if(e.keyCode == 13 || type=='search'){
      this.LoadData(1);
    }
  }

  ngAfterViewInit(){
    let that = this;
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
          that.activaType = item.selectItem || null;
          that.selectText = item["selectText"] || "";
          if(item["selectTabsIndex"] != null && item["selectTabsIndex"] != undefined){
            that.tabsIndex = item["selectTabsIndex"];
          }
        }
      })
    }
    switch(that.pageName){
      case 'ActivityCenter':
          that.LoadActivityData();
          break;
      // case 'MyStore':
      //     that.LoadDataInfo(1);
      //     break;
      default:
          that.LoadDataInfo(1);
    };
    let selectItem = that.element.selectItemList.selectItem;
    if(selectItem.length > 0){
      selectItem.forEach(item=>{
        if(item.elementType && item.elementType=="Search") {
          that.isShowSearchInput = true;
         that.searchPlaceholder = item.text;
        }
      })
    }

  }

  changeSelect(e){
    let that = this;
    that.activaType = e.target.value || "";
    if(that.activaType){
      that.activaArrayList.forEach((item)=>{
        if(item["a_Code"] == that.activaType){
          that.selectText = item["a_Name"];
        }
      })
      if(that.activaType == '001'){
        that.selectText = "全部";
      }
    }
    this.LoadData(1);

  }

  EventLink(event,item){
    // console.log(item);
    this.com.setHistoryUrl();
    if(event.url && item.actCode && item.actCode.value == "AT0004"){

      // this.router.navigate(["/tabs/contact/ActivityCenterDetail2/getedite/"+item.id.value+"&"+this.tabsIndex+"&"+this.com.getNowDatetime]);
      this.com.Go("/tabs/contact/ActivityCenterDetail2/getedite/"+item.id.value+"&"+this.tabsIndex+"&"+this.com.getNowDatetime);
    }else{
      let title = item["title"].value;
      let id = item['id'].value;
      localStorage.setItem("actNameAndId",JSON.stringify({Id:id,Name:title}));
      let _status = "begin";//活动状态
      //活动状态 1进行中 2未开始 0已结束
      if(this.tabsIndex == 0){
        _status = "end"
      }else if(this.tabsIndex == 1){
        _status = "begin"
      }else if(this.tabsIndex == 2){
        _status = "unbegin"
      }
      localStorage.setItem("actDetailJumpStatus",_status);
      // this.router.navigate([event.url+"getedite/"+item.id.value+"&"+this.tabsIndex+"&"+this.com.getNowDatetime]);
      this.com.Go(event.url+"getedite/"+item.id.value+"&"+this.tabsIndex+"&"+this.com.getNowDatetime)
    }
    // 
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadDataInfo(PageNumber){
    let that = this;
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    body.RequestBody = {"flag":that.tabsIndex};
    if(that.activaType && that.activaType != "001"){
      body.RequestBody["c_Code"] = that.activaType;
    }
    if(that.searchValue){
      let selectItem = that.element.selectItemList.selectItem;
      if(selectItem.length > 0){
        selectItem.forEach(item=>{
          if(item.elementType && item.elementType=="Search") {
            body.RequestBody[item.field] = that.com.LikeSearch(that.searchValue.trim());
          }
        })
      }
    }

    const _searchObj = {
      pageName:PageName,
      searchInput:that.searchValue,
      selectItem:that.activaType,
      selectText:that.selectText,
      selectTabsIndex:that.tabsIndex
    };
    that.com.SaveSearchInfo(_searchObj);

    body.RequestBody = JSON.stringify(body.RequestBody);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
       
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
            }
            if((element.bindingField == 'Deadline' || element.bindingField == 'starttime' || element.bindingField == 'endtime') && objfield[element.bindingField].value){
              objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
            }
          });
          that.dataArrayList.push(objfield);
          // console.log(that.element.selectItemList.selectItem);
          //console.log(that.dataArrayList);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }

 /**
  * 签到地址二维码
  * 
  */
 orderQRCode(url){
  this.com.setHistoryUrl(); 
  this.com.goQrCode(url, 'activityCode',"扫码签到");
 }

 /**
  * 获取对应活动的类型
  * @param tabsIndex 选中的活动类型
  */
 getActivityDataFormType(tabsIndex){
  if(this.tabsIndex != tabsIndex){
    this.tabsIndex = tabsIndex;
    this.LoadData(1);
    const _searchObj = {
      pageName:this.pageName,
      searchInput:this.searchValue,
      selectItem:this.activaType,
      selectText:this.selectText,
      selectTabsIndex:this.tabsIndex
    };
    this.com.SaveSearchInfo(_searchObj);
  }
 }

 LoadData(PageNumber){
  if(!this.initLoadData){
    this.LoadDataInfo(PageNumber);
  }else{
    this.initLoadData = false;
  }
}


LoadActivityData(){
  let that = this;
  // console.log("1008611");
  // console.log(that.element);
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  let id = that.activaRouter.snapshot.paramMap.get('id');
  let body = new WebParameterContext();
 
  body.ConfigName = "TBActivityTypeXML";
  // body.ConfigName="MemberManage";
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = 100;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  that.http.post(app.DEFAULTURL, body).then(data => {
    if (data.ResponseMessage.Success) {
      that.activaArrayList = data.Status.Datas;
      if(!that.activaType){
        that.activaType = "001";
        that.selectText = "全部";
      }
      that.LoadDataInfo(1);
    }
  }).catch(error => {
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading = true;
    console.log(error);
  });
}

   /**
   * 
   * @param date1 活动结束后3天之内 3天之外为true
   * 新增，结束后7天之内，不跨月
   */
  DateComparisonEnd(date){
    console.log(date);
    if(!date){
      return false;
    }
    let actYear = new Date(date.replace(/-/g,"/")).getFullYear();
    let actMonth = new Date(date.replace(/-/g,"/")).getMonth() + 1;
    let actDay = new Date(date.replace(/-/g,"/")).getDate();
    let actMonthDays = new Date(actYear,actMonth,0).getDate();
    let comparisonDays = app.activityChangeEndDate;//结束7天之内，不跨月
    if((actMonthDays-actDay)<7){
      comparisonDays = actMonthDays-actDay;
    }
    let actDate = new Date(date.replace(/-/g,"/")).getTime()+ comparisonDays * 24 * 60 * 60 * 1000;//结束日期
    return actDate;
  }
}
